<div class="popup-main popup--overlay" *ngIf="!ispopUpShow" style="display: flex;">
  <div class="popup">
    <div class="title">
      <span class="mr-2 info-icon material-symbols-outlined"> info </span>
      Program Information
    </div>
      <button class="popup--close"><span class="icon-close1" (click)="closePop()"></span></button>
      <div class="popup__content">
          <p>{{ desc}}</p>
      </div>

  </div>
  </div>